import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmOffersAndIncentivesSelection = (value) => {
    const gtmPayload = filterUndefinedAndEmptyValues({
        event: 'bap_payment_offers',
        offer_name: value.offerName,
        incentive_name: value.incentiveName,
    });
    gtmEvent(gtmPayload);
};
export default gtmOffersAndIncentivesSelection;
